import request from '../utils/request'
import baseUrl from './baseUrl'

export const supList = (data) => request({
  url: baseUrl + '/supplier/selectAll',
  method: 'POST',
  data
})